import React from "react";
import FAQ from "../../containers/FAQ/Faq";

const FaqPage: React.FC<{}> = () => <FAQ />

export default FaqPage;